"use client";

/**
 * PostDetailShareButton 컴포넌트
 * @description 글 상세 헤더의 공유 — 공용 `ShareButton` 에 계측만 얹는다(콜랩 상세와 같은 방식).
 */
import { memo, useCallback } from "react";

import type { PostDetailShareButtonProps } from "./PostDetail.types";

import { trackBlogShared } from "../../analytics";
import { blogCopyOf } from "../../constants/blogCopy";
import type { ShareOutcome } from "@/shared/lib/share";
import { ShareButton } from "@/shared/ui";

const PostDetailShareButton = memo<PostDetailShareButtonProps>(
  ({ post, title }) => {
    const onShared = useCallback(
      (outcome: ShareOutcome) => trackBlogShared(post, outcome),
      [post],
    );
    const copy = blogCopyOf(post).share;
    return (
      <ShareButton
        title={title}
        onShared={onShared}
        label={copy.label}
        copiedLabel={copy.copied}
      />
    );
  },
);

PostDetailShareButton.displayName = "PostDetailShareButton";

export default PostDetailShareButton;
